import { storyblokEditable } from "@storyblok/react";
const truncate = (str, limit) => {
  return str.length > limit ? str.substring(0, limit) + "..." : str;
};

const ImageSlider = ({ blok }) => {
/*   console.log("test", blok.blockSLider); */
  return (
    <div className="imageslider-content ">
      <img src={blok.image.filename} alt={blok.image.alt} />
      <div className="imageslider-transparenz">
        {blok.subheadline_text && (<h2 className="text-xl pb-2">{blok.subheadline_text}</h2>)}
        {blok.headline_text && (<h1 className="text-2xl pb-2">{blok.headline_text}</h1>)}
        <p className="pb-4">{truncate(blok.infotext, 300)}</p>
        <span>{blok.author_and_location}</span>
      </div>
    </div>
  );
};

export default ImageSlider;
